import { inject } from 'vue';
import type { ModalManager } from '@/plugins/vue-modal.ts';

export const useModal = (): ModalManager => {
    const $modal = inject<ModalManager>('$modal');

    if (!$modal) {
        throw new Error('useModal() requires the VueModal plugin to be installed');
    }

    return $modal;
};
